<template>
  <div>
    <div class="about">
      <div class="header-image" :style="'background-image:url(' + featuredImage + ');'" v-if="featuredImage">
        <SubTopNav v-if="title" title="Doing Business In Ekiti" />
      </div>
      <div v-else :class="'header-image default-header-' + rand">
        <SubTopNav v-if="title" title="Doing Business In Ekiti" />
      </div>

      <div class="page-content">
        <div class="db-business-tab">
          <b-tabs content-class="mt-3">
            <b-tab :title="tab.label" v-for="(tab, index) in availableCats" :key="index" @click="selectedCat = tab.id">
              <div class="db-business-grid">
                <div class="content-body item animated fadeInUp" v-for="item in group" :key="item.nid" v-show="selectedCat == item.field_dbcategory_1" @click="openLink(item)">
                  <h4 v-html="item.title"></h4>
                  <div :class="['category', 'category-' + item.field_dbcategory_1]">{{ item.field_dbcategory }}</div>
                  <!-- <div class="img"><img :src="baseDomain + item.field_image" v-if="item.field_image" /></div> -->
                  <!-- <div v-html="item.body"></div> -->
                </div>
                <!-- <div  class="content-body item animated fadeInUp">
	    			<h3>Starting a Business</h3>
	    			<div class="img"><img src="../assets/business-start.jpg"></div>
	    			<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla luctus a orci a lobortis. Phasellus eu leo vel odio gravida aliquam. Nunc elementum aliquet magna sed convallis. Sed aliquet id ligula vel vulputate. Etiam bibendum at magna sit amet convallis. Donec tincidunt, mauris luctus maximus eleifend, dolor enim consequat metus, nec sodales lectus lectus sed sapien. Sed efficitur nulla eget facilisis tempor. Donec a sapien velit.</p>
	    			<ol>
	    				<li><strong><a href="#">Business Registration &raquo;</a></strong></li>
	    				<li><strong><a href="#">Registering Property &raquo;</a></strong></li>
	    				<li><strong><a href="#">Paying Taxes &raquo;</a></strong></li>
	    				<li><strong><a href="#">Utility Connection &raquo;</a></strong></li>
	    			</ol>
	    		</div> -->
                <!-- <div class="content-body item animated fadeInUp">
	    			<h3>How to Run a Business</h3>
	    			<div class="img"><img src="../assets/business-do.jpg"></div>
					<p>Aliquam id hendrerit arcu. Etiam in ornare purus, ut fermentum ante. In efficitur eget nulla eget accumsan. Donec non enim diam. In dignissim placerat rhoncus. Ut luctus nibh mollis, egestas ligula non, sollicitudin risus. Donec molestie felis vitae luctus rutrum. Nullam pretium mi est, a vestibulum metus posuere quis. Integer erat magna, fermentum imperdiet lectus eget, interdum dictum eros. </p>
					<ol>
						<li><strong><a href="#">Enforcing Contracts &raquo;</a></strong></li>
						<li><strong><a href="#">Financing your Business &raquo;</a></strong></li>
						<li><strong><a href="#">Toolkits &raquo;</a></strong></li>
					</ol>
	    		</div> -->
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import { mapState } from "vuex"
import SubTopNav from "@/components/SubTopNav.vue"
import { RepositoryFactory } from "@/repositories/RepositoryFactory"
const ContentRepository = RepositoryFactory.get("content")

export default {
  name: "about",
  components: {
    SubTopNav,
  },
  data: function() {
    return {
      content: null,
      image: null,
      featuredImage: null,
      contentImages: [],
      group: [],
      availableCats: [],
      selectedCat: null,
      contentBody: null,
      title: null,
      rand: 1,
      tagline: null,
      siblings: [],
    }
  },
  methods: {
    async getNode(id) {
      // var id = "2"
      const { data } = await ContentRepository.getNode(id)
      // console.log('home page data', data)

      this.title = data.title[0].value
      this.tagline = data.body[0].summary
      this.featuredImage = data.field_feature_image && data.field_feature_image[0] && data.field_feature_image[0].url ? data.field_feature_image[0].url : null
      this.contentImages = data.field_content_image_s_

      this.contentBody = data.body

      // this.getSiblings()
    },
    async getGroup(type) {
      const { data } = await ContentRepository.getGroup(type)
      this.group = data
      this.group.reverse()

      var tempArray = this.group

      const groupBy = (array, property) =>
        array.reduce(
          (grouped, element) => ({
            ...grouped,
            [element[property]]: [...(grouped[element[property]] || []), element],
          }),
          {}
        )

      const groupedByType = groupBy(tempArray, "field_dbcategory_1")
      // this.availableCats = groupedByType

      // console.log("groupedByType", groupedByType)

      for (const [key, value] of Object.entries(groupedByType)) {
        // console.log("in here")
        var tempValue = value
        this.availableCats.push({
          id: `${key}`,
          label: tempValue[0].field_dbcategory,
        })

        // console.log("availablecats", this.availableCats)
      }

      this.selectedCat = this.availableCats[0].id

      // console.log("group", data)

      // this.getSiblings()
    },

    getItem(alias) {
      var aliasName = alias.split("/").pop()
      var path = "/sector/" + aliasName

      this.$router.push(path)
    },
    openLink(item) {
      var link = item.field_linkedin ? item.field_linkedin : "https://www.ekdipa.com.ng/" + item.field_attachment
      if (link) {
        window.open(link)
      }
    },
    // getSiblings(){
    // 	var navigation = this.$session.get('navigation')
    // 	var pageTitle = this.title.toLowerCase()
    // 	if (navigation && navigation.length){
    // 		var menuItemArr = navigation.filter(function (item){
    //         return item.name.toLowerCase() == pageTitle
    //       })

    //       var menuItem = menuItemArr[0]
    //       var menuParent = menuItem.parent

    //       if (menuParent){
    //       	var siblingsArr = navigation.filter(function (item){
    //       		return (item.parent == menuParent) && (item.name.toLowerCase() != pageTitle)
    //       	})

    //       	this.siblings = siblingsArr

    //       }

    //       // console.log('sub expertise', this.subExpertise)
    // 	}
    // }
  },
  computed: {
    ...mapState(["baseDomain"]),
  },
  mounted() {
    var api = this.$route.meta.api
    if (api && api.length && api.length > 0) {
      api.forEach((item) => {
        if (item.type == "node") {
          this.getNode(item.id)
        }
        if (item.type == "group") {
          this.getGroup(item.id)
        }
      })
      // if (api.type == "node"){
      // 	this.getNode(api.id)
      // } else if (api.type == "group") {
      // 	this.getGroup(api.id)
      // } else {

      // }
    }

    this.rand = Math.floor(Math.random() * 8) + 1
  },
}
</script>
<style scoped>
.page-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 25px;
}

.about {
  overflow-x: hidden;
}

.page-grid .item {
  xbackground: #ccc;
  xpadding: 10px;
}

.page-grid .item:nth-child(1) {
  xborder: 1px solid red;
  xgrid-column: 1 / 3;
  border-top: 5px solid #339900;
  padding-top: 20px;
  margin-top: 20px;
}

.page-grid .item:nth-child(1) .body-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: #f7f1eb;
  xborder: 10px solid #e1e1e1;
  xpadding: 25px;
  grid-gap: 25px;
  margin-top: 25px;
  xborder-radius: 0px 0px 85px 0px;
}

.img {
  max-height: 300px;

  margin-bottom: 40px;
  overflow: hidden;
  background: #339900;
}

.img img {
  opacity: 0.7;
}

.page-grid .item:nth-child(1) .body-row div:nth-child(1) {
  padding: 25px;
}

.page-grid .item:nth-child(1) .body-row div:nth-child(2) h3 {
  margin-top: 55px;
}

.page-grid .item:nth-child(1) .body-row div:nth-child(2) {
  xpadding: 25px;
}

.page-grid img {
  width: 100%;
}

.page-grid .item:nth-child(2) {
  border-top: 5px solid #08b7de;
  padding-top: 20px;
  margin-top: 20px;
}

.page-grid .item:nth-child(3) {
  border-top: 5px solid #663300;
  padding-top: 20px;
  margin-top: 20px;
}

.page-grid .item:nth-child(4) {
  xborder-top: 5px solid #339900;
  color: #fff;
  background: #339900;
  font-size: 120%;
  padding: 20px 320px;
  margin-left: -300px;
  margin-right: -300px;
  margin-top: 20px;
  grid-column: 1 / 3;
}

.page-content {
  text-align: left;
  xmargin-bottom: 30px;
}

.image-break {
  height: 300px;
  xbackground: #ccc;
  margin-top: 35px;
  margin-bottom: 35px;
}

.image-box {
  height: 300px;
  top: 0;
  left: 0;
  filter: grayscale(100%);
  xopacity: 0.3;
}

.image-text {
  margin-top: -300px;
  z-index: 50;
  position: relative;
}

.image-text a {
  color: #fff;
}

.image-text .container div {
  background: rgba(255, 102, 0, 0.8);
  color: #fff;
  padding: 105px 50px 50px 50px;
  float: left;
  width: 50%;
  height: 300px;
}

.page-content .content-body:nth-child(2n) .image-text .container div {
  float: right;
  background: rgba(102, 153, 51, 0.8);
}

.item-group {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 25px;
}

.group-item {
  xpadding: 25px;
  box-shadow: 3px 3px 5px #ccc;
  background-size: 25px;
  cursor: pointer;
  border-radius: 0 0 25px 0;
  margin-bottom: 40px;
}

.group-item .name {
  padding: 25px;
}

.page-subheader {
  margin-top: 40px;
}

.group-item img {
  width: 100%;
}

.group-item .img {
  height: 250px;
  overflow: hidden;
}

.body-row {
  xpadding: 25px;
}

.db-business-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 25px;
  margin-bottom: 50px;
}

.db-business-grid .item {
  box-shadow: 3px 3px 5px #ccc;
  padding: 25px 50px;
  border-radius: 5px;
  cursor: pointer;
}

.db-business-grid .item:hover {
  background: #ccc;
}

.db-business-grid .category {
  padding: 5px 10px;
  background: green;
  border-radius: 5px;
  display: inline-block;
  color: #fff;
  font-size: 80%;
}

.db-business-grid .category-38 {
  background: #0099cc;
}

.nav-tabs li.nav-item a {
  color: green !important;
}

@media (max-width: 768px) {
  .db-business-grid {
    grid-template-columns: 1fr;
  }
}
</style>
